export default __webpack_public_path__ + "assets/c90bbebfc11b16b3a5a592d593c51584.png";